import { Component, Output, EventEmitter} from "@angular/core";
import {  AlertController, ModalController} from "@ionic/angular";
import { AnmeldungenPage } from "../anmeldungen-page/anmeldungen-page";
import { Router } from "@angular/router";

@Component({
    selector: 'add-athlete',
    templateUrl: 'add-athlete.html',
    styleUrls:['./add-athlete.scss']
})

export class AddAthletePage{
@Output() athleteEvent = new EventEmitter<any>();
minuteValues = ['00', '15', '30', '45'];
secondsList = Array.from({ length: 60 }, (_, i) => i);
timeWithoutSeconds: string = '';
seconds: number = 0;

hourValues = Array.from({ length: 24 }, (_, i) => (i < 10 ? '0' + i : '' + i));
athleteData = {
    firstName: '',
    lastName: '',
    bibNo: '',
    time: '',
    eventId: 0
};
eventId: number;
routerState:any;



constructor( 
    private router:Router, 
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
){
    const nav = this.router.getCurrentNavigation();
    this.routerState = nav?.extras?.state || {};
    this.getData();
    if (this.athleteData && this.athleteData.time) {
        const date = new Date(this.athleteData.time);

        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = date.getSeconds();

        this.timeWithoutSeconds = `1970-01-01T${hh}:${mm}`;
        this.seconds = ss;
    }
}

getData(){
    this.eventId = this.routerState["eventId"];
}
async addNewAthlete(){
    if(this.athleteData.firstName.length !== 0){
        this.athleteData.eventId = this.eventId;
        await this.modalCtrl.dismiss(this.athleteData);
    }
    else{
       this.alertCtrl.create({
            header: 'Please, add athlete name',
            buttons: ['Okay']
        }).then(alert=>{
            alert.present();
        });
    }
}
async onBackMenu(){
    // this.viewCtrl.dismiss(this.athleteData);
    await this.modalCtrl.dismiss(this.athleteData)
}
    updateTime() {
        if (!this.timeWithoutSeconds) return;
        const date = new Date(this.timeWithoutSeconds);
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(this.seconds).padStart(2, '0');
        this.athleteData.time = `${hh}:${mm}:${ss}`;
    }

}